import { $api } from './interceptor';
import { IOrderQueueResponse } from 'views/types/orderQueue';

export interface IOrderQueueParams {
  type?: 'SWAP' | 'WITHDRAW';
  page?: number;
  pageSize?: number;
  onlyLocked?: boolean;
  onlyErrors?: boolean;
  search?: string;
}

const orderQueueApi = () => {
  const getOrderQueue = async (params: IOrderQueueParams) => {
    const { data } = await $api.get<IOrderQueueResponse>(
      '/api/admin/order-queue',
      { params }
    );
    return data;
  };

  const retry = async (id: string) =>
    (await $api.post(`/api/admin/order-queue/${id}/retry`)).data;

  const forceExternal = async (id: string) =>
    (await $api.post(`/api/admin/order-queue/${id}/force-external`)).data;

  const unlock = async (id: string) =>
    (await $api.post(`/api/admin/order-queue/${id}/unlock`)).data;

  return {
    getOrderQueue,
    retry,
    forceExternal,
    unlock,
  };
};

export const orderQueueService = orderQueueApi();
